
import React, { useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import './team.css';
 
const teamMembers = [
  {
    name: "Zeka King Banda",
    role: "Team Leader, Founder & CEO — Mechanical Technician Engineer",
    email: "divine-tech.engineering@gmail.com",
    image: "/images/logo.jpeg",
    highlights: [
      "Mechanical fitting & maintenance",
      "Water systems specialist",
      "Solar pumping expert",
      "Engineering project leadership",
      "renewable energy systems specialist",
    ],
  },
  {
    name: "James Kachilonda",
    role: "Plumber",
    email: "divine-tech.engineering@gmail.com",
    image: "/images/logo.jpeg",
    highlights: [
      "Pipeline installation & rehabilitation",
      "Leak detection and repairs",
      "Pump installation support",
      "Water supply system troubleshooting",
    ],
  },
   
  {
    name: "Wanangwa Phiri",
    role: "Worksop Assistant",
    email: "divine-tech.engineering@gmail.com",
    image: "/images/logo.jpeg",
    highlights: [
      "workshop organization",
      "Fabrication support",
      "Material handling",
      "Inventory management",
    ],
  },
  {
    name: "Peter Chapotela",
    role: "Marketing & Finance Manager",
    email: "divine-tech.engineering@gmail.com",
    image: "/images/logo.jpeg",
    highlights: [
      "Business development & client relations",
      "Financial planning and reporting",
      "Marketing strategy & outreach",
    ],
  },
  {
    name: "Watson Jamison",
    role: "General Fitter",
    email: "divine-tech.engineering@gmail.com",
    image: "/images/logo.jpeg",
    highlights: [
      "Structural fitting & assembly",
      "On-site installations",
      "Preventative maintenance",
    ],
  },
  {
    name: "Innocent Maganga",
    role: "Welder",
    email: "divine-tech.engineering@gmail.com",
    image: "/images/logo.jpeg",
    highlights: [
      "MIG/TIG & stick welding",
      "Fabrication finishing",
      "Metal repairs and joinery",
    ],
  },
  {
    name: "Jeremire Chinyama",
    role: "Electrical & Solar Technician",
    email: "divine-tech.engineering@gmail.com",
    image: "/images/logo.jpeg",
    highlights: [
      "Solar array installation",
      "Electrical wiring & panels",
      "System testing & commissioning",
    ],
  },

  {
    name: "Isaac King Banda",
    role: "ICT And Innovations Officer",
    email: "divine-tech.engineering@gmail.com",
    image: "/images/logo.jpeg",
    highlights: [
      "Digital tools & data handling",
      "Systems and communication support",
      "Operations coordination",
      "Innovation research & development",
      "Technical documentation",
    ],
  },
  {
    name: "Chancy Chimera",
    role: "Welding & Fabrication Technician",
    email: "divine-tech.engineering@gmail.com",
    image: "/images/logo.jpeg",
    highlights: [
      "Custom fabrication",
      "Sheet metal & structural work",
      "Quality control and finishing",
    ],
  },
  {
    name: "Misheck Kachilonda",
    role: "Sales & Logistics Assistant",
    email: "divine-tech.engineering@gmail.com",
    image: "/images/logo.jpeg",
    highlights: [
      "Order coordination",
      "Inventory & dispatch support",
      "Client liaison",
    ],
  },
  {
    name: "Hannah Banda",
    role: "Public Relations Manager",
    email: "divine-tech.engineering@gmail.com",
    image: "/images/logo.jpeg",
    highlights: [
      "Media & community relations",
      "Communications strategy",
      "Event coordination",
    ],
  },
];
 
function Team({ embedded = false }) {
  const [activeIndex, setActiveIndex] = useState(0);
 
  const activeMember = useMemo(() => {
    return teamMembers[Math.min(Math.max(activeIndex, 0), teamMembers.length - 1)];
  }, [activeIndex]);
 
  return (
    <section className={`team-section ${embedded ? 'team-section--embedded' : ''}`} id={embedded ? 'team' : undefined}>
      <Container className="team-wrap">
        <div className="team-top">
          <div className="team-top-title">Team</div>
          <div className="team-top-subtitle">
            We have qualified, certified team members with proven field experience in water systems, mechanical works, and
            fabrication.
          </div>
        </div>
        {embedded ? (
          <div className="team-grid" role="list">
            {teamMembers.map((member) => (
              <article className="team-card" key={member.name} role="listitem">
                <div className="team-card-img-wrap">
                  <img className="team-card-img" src={member.image} alt={member.name} />
                  <div className="team-card-overlay" aria-label={`${member.name} skills`}>
                    {/* <div className="team-card-overlay-title">Skills</div> */}
                    <ul className="team-card-overlay-list">
                      {member.highlights.map((highlight) => (
                        <li key={highlight}>{highlight}</li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="team-card-body">
                  <div className="team-card-name">{member.name}</div>
                  <div className="team-card-role">{member.role}</div>
                  {/* <a className="team-card-cta" href={`mailto:${member.email}`} aria-label={`Email ${member.name}`}>Contact</a> */}
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="team-split">
            <div className="team-left">
              <h2 className="team-left-title">Meet Our Exceptional Team</h2>
              <p className="team-left-text">
                Click a team member to view their role, qualifications, and key strengths. We focus on safety, quality
                workmanship, and dependable service delivery.
              </p>
 
              <div className="team-stats">
                <div className="team-stat">
                  <div className="team-stat-value">Qualified</div>
                  <div className="team-stat-label">Technicians & installers</div>
                </div>
                <div className="team-stat">
                  <div className="team-stat-value">Certified</div>
                  <div className="team-stat-label">Workmanship & compliance</div>
                </div>
                <div className="team-stat">
                  <div className="team-stat-value">Field-ready</div>
                  <div className="team-stat-label">Reliable on-site delivery</div>
                </div>
              </div>
 
              <div className="team-detail">
                <div className="team-detail-head">
                  <div className="team-detail-name">{activeMember.name}</div>
                  <div className="team-detail-role">{activeMember.role}</div>
                </div>
                <ul className="team-detail-list">
                  {activeMember.highlights.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
                {/* <a className="team-detail-cta" href={`mailto:${activeMember.email}`} aria-label={`Email ${activeMember.name}`}>
                  <FaEnvelope /> Contact
                </a> */}
              </div>
            </div>
 
            <div className="team-right">
              <div className="team-portraits" role="list">
                {teamMembers.map((member, idx) => (
                  <button
                    key={member.name}
                    type="button"
                    className={`team-portrait ${idx === activeIndex ? 'is-active' : ''}`}
                    style={{ backgroundImage: `url(${member.image})` }}
                    onMouseEnter={() => setActiveIndex(idx)}
                    onFocus={() => setActiveIndex(idx)}
                    onClick={() => setActiveIndex(idx)}
                    aria-label={`${member.name} — ${member.role}`}
                    role="listitem"
                  >
                    <span className="team-portrait-overlay">
                      <span className="team-portrait-name">{member.name}</span>
                      <span className="team-portrait-role">{member.role}</span>
                      <span className="team-portrait-skills" aria-hidden="true">
                        {member.highlights.slice(0, 2).map((skill) => (
                          <span key={skill} className="team-portrait-skill">• {skill}</span>
                        ))}
                      </span>
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </Container>
    </section>
  );
}
 
export default Team;
 
 